var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "up-down-arrow",
    "data-name": "Flat Color",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon flat-color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "M11.71,6.29l-3-3a1,1,0,0,0-1.42,0l-3,3A1,1,0,0,0,5.71,7.71L7,6.41V20a1,1,0,0,0,2,0V6.41l1.29,1.3a1,1,0,0,0,1.42,0A1,1,0,0,0,11.71,6.29Z",
    style: {
      fill: "#00BCD1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M19.71,16.29a1,1,0,0,0-1.42,0L17,17.59V4a1,1,0,0,0-2,0V17.59l-1.29-1.3a1,1,0,0,0-1.42,1.42l3,3a1,1,0,0,0,1.42,0l3-3A1,1,0,0,0,19.71,16.29Z",
    style: {
      fill: "#000000"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsUpDown);
export default __webpack_public_path__ + "static/media/IconsUpDown.7eb220e686bcd5d1d7562b451ffc6fb1.svg";
export { ForwardRef as ReactComponent };